import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        name: "Anjani Raj",
        resumeLink: "https://drive.google.com/open?id=1i7FTQpQBqFvl_pqmGr79emxMJiC1AqXS",
        sections: [
            'About', 'Work', 'Publications', 'Contact'
        ],
        IntroData: {
            aboveNameText: "Hello! I am",
            nameText: "Anjani Raj.",
            tagLine: 'I am a creator.',
            belowNameText: "I'm a Software Developer currently based in Bangalore, India. I am good in Machine Learning and Blockchain " +
                "technologies."
        },
        AboutData: {
            para1: "Hello there! I'm Anjani Raj, a software engineer, who is skilled in building  " +
                "the complete microservices backend . I am currently working as a Software Developer in Publicis Sapient and Home, in Bengaluru. " +
                "In my free time, I like to bake delicious goodies and build 3D models! ",

            para2: "I have done my graduation from National Institute of Technology, Delhi (NIT Delhi) in Computer Science and " +
                "Engineering. During my time there, I have learnt and developed many projects encompassing various technologies.",

            techStack: [
                "Tensorflow", "Advanced Python", "Hyperledger Fabric", "Ethereum", "Go", "Solidity",
                "Hadoop", "MongoDB", "SQL","Octave/MATLAB", "Microservices Development (Spring and Netflix OSS tools)",
                "Frontend Development (React, Vue)", "Tetsing (Junit, Jmeter, Selenium, Cucumber)", "Docker", "AWS",
                "CI/CD pipelines (Jenkins)", "Android App Development", "Actions on Google", "FireBase",
                "BlockChain","ELK"
            ],

            currentJob: "Publicis Sapient and Home, in Bengaluru. "
        },

        WorkData: [
            {
                companyName: "Publicis Sapient",
                duration: "July 2019 - Present",
                role: "Software Development Engineer",
                highlights: [
                    "Develeped an e-commerce website with a fully fledged SpringBoot microservice backend and React.Js frontend" +
                    "Created multiple CI/CD pipelines",
                    "Deployed applications on cloud platforms",
                    "Working with a variety of different frameworks, languages and platforms.",
                    "Effectively communicating across various departments and multi-disciplinary teams."
                ]
            },
            {
                companyName: "Fidelity International",
                duration: "June 2018 - July 2018",
                role: "Research Intern",
                highlights: [
                    "Worked on creating a research based framework of Enterprise Blockchain using Hyperledger Fabric and Distributed AI technologies " +
                    "to solve the problem of onboarding massive financial data.",
                    "Worked with Hyperledger, Ethereum and Tensorflow "
                ]
             }//,
            // {
            //     companyName: "MyCaptain, The Climber",
            //     duration: "June 2019 - Present",
            //     role: "Android Workshop Mentor",
            //     highlights: [
            //         "Mentor students new to Android development on the MyCaptain platform. ",
            //         "Assign mentees tasks and solve their doubts, while refining their debugging skills.",
            //         "Mentored 160 students over 4 months uptil now."
            //     ]
            // }
        ],

        // projectsData: [
        //     {
        //         name: "Billy, the Math Star!",
        //         description: "Developed an Action on Google (Google Assistant Voice App) named Billy. Billy will ask " +
        //             "simple math questions for kids to test their knowledge. A fun way for kids to learn while interacting  " +
        //             " with the Google Assistant.",
        //         technologies: [
        //             "DialogFlow API", "Actions on Google", "Firebase Functions", "Javascript"
        //         ],
        //         screenshot: 'sc_slide.png',
        //         githubLink: "https://github.com/Hydrino/Billy-the-Maths-star",
        //         externalLink: null,
        //         featured: true
        //     },
        //     {
        //         name: "Slide - Wallpaper SlideShow ",
        //         description: "Select your favorite images and Slide will set up a slideshow of your images as your phone's wallpaper." +
        //             " Currently the app has more than 100,000 downloads on the Play Store.",
        //         technologies: [
        //             "Android", "Material Design", "Java", "XML", "Gradle"
        //         ],
        //         screenshot: 'sc_slide.png',
        //         githubLink: null,
        //         externalLink: "https://play.google.com/store/apps/details?id=ninhydrin.ninad.com.slide&hl=en_US",
        //         featured: true
        //     },
        //     {
        //         name: "Doodly",
        //         description: "Fun app that lets users draw a doodle and then predict what is drawn using Convolutional Neural Nets." +
        //             " Used Tensorflow Lite API to transfer the model to an Android app. ",
        //         technologies: [
        //             "Convolutional Neural Nets", "Tensorflow", "Python", "Deep Learning", "Android"
        //         ],
        //         screenshot: 'sc_slide.png',
        //         githubLink: "https://github.com/Hydrino/Doodly",
        //         externalLink: "https://www.dropbox.com/s/ubs60kel94f89xf/doodly.apk?dl=0",
        //         featured: true
        //     },
        //     {
        //         name: "Poll",
        //         description: "Realtime polling app made for my college to get students' anonymous votes on uploaded issues.",
        //         technologies: [
        //             "Android", "Firebase Realtime Database", "Kotlin", "RxJava2", "OkHttp3"
        //         ],
        //         githubLink: "https://github.com/Hydrino/Poll2",
        //         externalLink: "https://www.dropbox.com/s/azqfosfw7f46gvo/poll.apk?dl=0",
        //         featured: false
        //     },
        //     {
        //         name: "AC-GAN Cifar10",
        //         description: "A PyTorch implementation of Auxiliary Classifier GAN (acgan) to generate CIFAR10 dataset images. ",
        //         technologies: [
        //             "Pytorch", "GANs", "Python", "Deep Neural Nets", "ACGAN"
        //         ],
        //         githubLink: "https://github.com/Hydrino/ACGAN_cifar10",
        //         externalLink: null,
        //         featured: false
        //     },
        //     {
        //         name: "MailBox",
        //         description: "Simple Android application that lets users sign up and send letters to each other.",
        //         technologies: [
        //             "Android", "SQL Database", "PHP", "Custom components", "Spring Animations"
        //         ],
        //         githubLink: "https://github.com/Hydrino/MailBox",
        //         externalLink: "https://www.dropbox.com/s/0s5j8y64cqyg3rx/mailbox.apk?dl=0",
        //         featured: false
        //     },
        //     {
        //         name: "AC-GAN MNIST",
        //         description: "An Auxiliary Classifier GAN (acgan) implementation in PyTorch to generate MNIST digits. ",
        //         technologies: [
        //             "Pytorch", "GANs", "Python", "Deep Neural Nets", "ACGAN"
        //         ],
        //         githubLink: "https://github.com/Hydrino/ACGAN_mnist",
        //         externalLink: null,
        //         featured: false
        //     },
        //     {
        //         name: "Personal Website",
        //         description: "Developed and designed a landing page for myself using Vue and hosted on Github pages.",
        //         technologies: [
        //             "Web development", "Vue", "Vuetify", "Javascript", "HTML", "CSS"
        //         ],
        //         githubLink: "https://github.com/Hydrino/PersonalWebsite",
        //         externalLink: "https://hydrino.github.io/#/",
        //         featured: false
        //     }
        // ],

        ContactData: {
            title: "Get in touch",
            message: "Always appreciate when someone reaches out to me. Whether it a job opportunity" +
                " or a potential project, or even just to say hi, drop in a mail!",
            email: "anjani.madhu97@gmail.com"
        },

        footerData: [
            {
                icon: 'fab fa-github',
                link: 'https://github.com/AnjaniRaj',
                title: "Github"
            },
            // {
            //     icon: 'fab fa-twitter',
            //     link: 'https://twitter.com/NinHydrino',
            //     title: "Twitter"
            // },
            {
                icon: 'fab fa-linkedin',
                link: 'https://www.linkedin.com/in/anjani-raj-79659b111/',
                title: "LinkedIn"
            },
            {
                icon: 'fab fa-instagram',
                link: 'https://www.instagram.com/anjani__raj/',
                title: "Instagram"
            },
            {
                icon: 'fab fa-facebook',
                link: 'https://www.facebook.com/anjani.raj.9461',
                title: "Facebook"
            }

        ]

    },
    mutations: {},
    actions: {},
    getters: {
        getName: function (state) {
            return state.name;
        },
        getSections: function (state) {
            return state.sections;
        },
        getIntroData: function (state) {
            return state.IntroData;
        },
        getWorkData(state) {
            return state.WorkData;
        },
        getProjectsData(state) {
            return state.projectsData;
        },
        getResumeLink(state) {
            return state.resumeLink;
        },
        getAboutData(state) {
            return state.AboutData;
        },
        getContactData(state) {
            return state.ContactData;
        },
        getFooterData(state) {
            return state.footerData;
        }
    }
})
